module.exports = __webpack_public_path__ + "static/media/sa.5ef5a874.png";